module.exports = __webpack_public_path__ + "img/inside_bouloire-mobile.4f8b4ab7.webp";